import { FC } from 'react';
// component
import EditUserComponent from 'components/main/Users/View';

const EditUser: FC = () => <EditUserComponent />;

export default EditUser;
